// extracted by mini-css-extract-plugin
module.exports = {"userPanel":"userPanel___foaWZ","userPanelHeader":"userPanelHeader___17MU8","userPanelMenu":"userPanelMenu___zWPJV","avatar":"avatar___3E_tn"};